<!--
1. В таблицю dSetupObjectType додані типи об'єктів, які використовуються в D2catering. Їхня назва відрізняється
від старих префіксом "ot_" замість "ot".
2. Коли користувач переходить в розділ "Заклади", відкривається CustomerSideBar і заванатажується таблиця dSetupTree
3. Будується дерево об'єктів nodes глибиною максимум в 3 гілки від кореневої, наприклад:

ot_customers                        //Всі заклади (корінь)              52
    ot_custBranch                   //Група закладів                    53
        ot_cluster                  //Кластер корпоративних закладів    46
        ot_customer                 //Заклад інд замовлень              54
            ot_custConfig           //Розділ "параметри закладу"        45
            ot_clients              //Розділ "кліенти закладу"          55
            ot_menu                 //Розділ "меню закладу"             56
                ot_menuBranch       //Гілка дерева меню                 41


   Дерево nodes будується шляхом відокремлення шматка від дерева dSetupTree
4. Користувачу надається можливість створити / змінити "групу закладів" та "заклад".
5. Об'єкти налаштування ОН (ot_custConfig, ot_clients, ot_menu) можна додати в будь-яку гілку, включаючи корінь,
    але так, щоб в гілці не було двох однакових ОН (видалені ОН не враховуються)
6. Групу закладів, заклад і об'єкти налаштування (ОН) можна перегруповувати пересуванням.
7. ОН можна видалити через hide. Прихований ОН можна видалити остаточно.
8. Через кореневий пункт меню "Показати видалені" поруч із робочимии ОН покузуються видалені ОН. На кожному
    видаленому ОН є пункт меню "Видалити остаточно" та  "Відновити".
9. Відновити видалений ОН можна або пересуванням в іншу гілку, або через пункт меню "Відновити" за умови,
    що в гілці відновлення відсутній аналогічний неприхований ОН.
10. Якщо гілка мережі закладів або закладу порожня, її можна видалити остаточно, без hide
11. Коли користувач обирає ОН, відкривається відповідний компонент, в який через пропс передається ідентифікатор ОН

12. Сторінка використовує DDTree тільки в частині відображення дерева (ліва панель). Штатне випадаюче меню
замінене на локальне, модифікація вузлів дерева здійснюється локальними функціями.
-->

<template>
    <aside class='sidebar' :class="{ 'sidebar--collapsed': collapsed }" v-if="dataIsReady" >
        <button
            type="button"
            class="sidebar__toggle"
            :title="collapsed ? 'Розгорнути дерево закладів' : 'Згорнути дерево закладів'"
            @click="toggleCollapse"
        >{{ collapsed ? '»' : '«' }}</button>

        <div class="sidebar__tree" v-show="!collapsed">
            <DragAndDropTree
                resource            = "customers"
                :nodes              = "filteredNodes"
                :groupMenu          = "activeGroupMenu"
                :elementTableCols   = "[]"
                :onMoveNode         = "onMoveNode"
                :onSelectNode       = "onSelectNode"
                :onOpenNodeDropdown = "onOpenNodeDropdown"
                :onMenuCommand      = "onMenuCommand"
            ></DragAndDropTree>
        </div>

        <SidebarAccountFooter :collapsed="collapsed" />

        <el-dialog
        v-model="groupDialogVisible"
		:title="groupDialogData.title"
		:close-on-press-escape="true"
		@closed="groupDialogVisible = false"
	    >
            <div v-if="groupDialogData.action=='tool.add'" class="dialog-field">
                <label>Гілка:
                    <span>{{groupDialogData.parentName}}</span>
                </label>
                <div class="dialog-field">
                    <label>{{groupDialogData.label}} </label>
                    <el-checkbox-group v-model="groupDialogData.objects">
                        <el-checkbox v-for="item in tools"
                        :label="item.tag"
                        :value="item.code"
                        size="small"
                        :disabled="groupDialogData.origObjects.includes(item.code) ||
                            item.code =='ot_clients' && ['ot_customers','ot_custBranch'].includes(groupDialogData.parent_code)"
                        @change="onChangeObjectDailog(item.code)"
                        />
                    </el-checkbox-group>
                </div>
            </div>


            <div v-else>
                <div v-if="groupDialogData.parentName" class="dialog-field">
                    <label>Гілка:
                        <span>{{groupDialogData.parentName}}</span>
                    </label>
                </div>
                <div class="dialog-field">
                    <label> {{groupDialogData.label}}</label>
                    <el-input
                    :readonly="groupDialogData.readonly"
                    v-model="groupDialogData.name" size="small"
                    />
                </div>
            </div>

            <template #footer>
                <el-button @click="groupDialogVisible = false" size="small">Ні</el-button>
                <el-button type="primary" @click="onConfirmGroupDialog()" size="small">Так</el-button>
            </template>
	    </el-dialog>

    </aside>
</template>

<script setup>
import {ref,reactive,computed, onMounted,inject} from 'vue'
import { useRouter,useRoute } from 'vue-router'
import {arrayToMap,toMap,fillNewObjectArray,alertMessage} from '@/utils/common.js'
import { resolveClientsConfigId } from '@/utils/orderScope.js'
import DragAndDropTree from '@/components/Drag&DropTree.vue'
import SidebarAccountFooter from '@/components/SidebarAccountFooter.vue'
import { ElMessageBox } from 'element-plus'
import {useOTypeStore,useOTreeStore,firstLoad} from '@/stores/apiStore.js'

const st={
    ot      : useOTypeStore(),
    otTree  : useOTreeStore()
}

//глобальна змінна зберігає id поточної конфігурації з таблиці dSetupTree
//provide в App.vue
const configId = inject('configId',ref(null))
const dataIsReady = ref(false)
const router = useRouter()
const route = useRoute()

const SIDEBAR_COLLAPSE_KEY = 'customersSidebarCollapsed'
function readCollapsed() {
    try { return localStorage.getItem(SIDEBAR_COLLAPSE_KEY) === '1' } catch (e) { return false }
}
const collapsed = ref(readCollapsed())
function toggleCollapse() {
    collapsed.value = !collapsed.value
    try { localStorage.setItem(SIDEBAR_COLLAPSE_KEY, collapsed.value ? '1' : '0') } catch (e) {}
}

const rootIcon = computed(()=>showDeletedNode.value?
    "<span style='font-size:16px;margin:0 3px;color:red'>●</span>":""
)

function onSelectNode(node) {
    if(!node){
        router.push({path: "/customers"})
        return true
    }
    let nodeType = nodesPlanMap.get(node.object_type_code)
    configId.value = node.id
    if( nodeType.type == "tool"){
        let routePath
        if(nodeType.tag=="Клієнти")routePath="fClients"
        else if(nodeType.tag=="Меню")routePath="menu"
        else if(nodeType.tag=="Замовлення"){
            configId.value = resolveClientsConfigId(nodes.value, node.id)
            const parentNode = nodeMap.get(node.parent_id)
            const zaklad = parentNode ? String(parentNode.name || '').replace(/\s+\d+$/, '') : ''
            router.push({path: "/customers/orders", query: { id: node.id, zaklad }})
            return true
        }
        //Додаю в url id обраної obj гілки, щоб сторінка перевантажиляся в момент зміни id
        if(routePath)router.push({path: "/customers/" + routePath, query: {id:node.id}})
        return true
    }
    else if(nodeType.type == "cluster" || nodeType.type == "customer"){
        router.push({path: "/customers/lunches", query: {id:node.id}})
        return true
    }
    router.push({path: "/customers"})
    return true
}

async function onCreateNode(payload){return await st.otTree.create(payload)}
async function onUpdateNode(grpId,payload){return await st.otTree.update(grpId, payload)}
async function onRemoveNode(grp_id){return await st.otTree.deleteSoft(grp_id)}
async function onDeleteNode(grp_id){return await st.otTree.deleteHard(grp_id)}
async function onRestoreNode(grp_id){return await st.otTree.restore(grp_id)}
async function onMoveNode(nodeId,payload){
    let nodeCode = nodes.value.find(n=>n.id==nodeId)?.object_type_code || null
    let newParentChilds = nodes.value.filter(n =>
        n.parent_id == payload.parent_id && n.object_type_code=='ot_menu' && !n.hide)
    let newParentCode = nodes.value.find(n=>n.id==payload.parent_id)?.object_type_code || null
    if(newParentChilds.length>1){
        alertMessage("В гілці признечення вже існує інструмент 'Меню'")
        return false
    }
    if(['ot_cluster','ot_customer'].includes(nodeCode)
        && !['ot_customers','ot_custBranch'].includes(newParentCode)){
            alertMessage("Заклад можна пересунути тільки в корінь або в мережу")
            return false
    }
    return await st.otTree.moveNode(nodeId,payload)
}

function onOpenNodeDropdown(node){
    let otCode=node.object_type_code
    let nodePlan = nodesPlanMap.get(otCode)
    activeGroupMenu.value = structuredClone(showDeletedNode.value
        && (node.hide || nodePlan.type=='root')?nodePlan.hideOptions:nodePlan.options)
    //блокую штатні опції дроп меню DDTree
    activeGroupMenu.value.push({ name: "", obj: "group",act:"edit"})
    activeGroupMenu.value.push({ name: "", obj: "group",act:"delete"})
    activeGroupMenu.value.push({ name: "", obj: "group",act:"add"})
}

async function onMenuCommand({ menu, command, context}){
    if(menu !='groupMenu' || !context ) return
    if(command == "nodes-removed.show") {
        showDeletedNode.value=true
        return
    }
    if(command == "nodes-removed.hide") {
        showDeletedNode.value=false
        return
    }
    let nodePlan=nodesPlanMap.get(context.object_type_code)
    const {id,name,object_type_id,object_type_code,hide}=context
    let gdd={id,name,object_type_id,object_type_code,hide}

    const [commType, commAct] = command.split(".")

    if(["grp.add","tool.add","customer.add","cluster.add"].includes(command)){
        gdd.parentName = context.name
        gdd.parent_id  = context.id
        gdd.parent_code       = context.object_type_code
        gdd.name       = ""
        gdd.id         = null
    }
    else {
        gdd.parent_id  = context.parent_id
        gdd.parentName = nodeMap.get(context.parent_id)?.name || ""
    }
    let options = context.hide?nodePlan.hideOptions:nodePlan.options
    gdd.title = options.find(op=>op.obj+"."+op.act == command)?.name || ""
//console.log("options",options)
    gdd.action = command
    gdd.label =
        commType =='grp'?"Назва групи закладів":
        commType =='customer' ?"Назва закладу":
        commType =='cluster' ?"Назва корпоративного кластеру":
        commType =='tool'? "Інструмент:":""
    gdd.readonly = ['delete','restore','remove'].includes(commAct)

    gdd.origObjects = context.children
        .filter(el=>objTypeCodes.includes(el.object_type_code))
        .map(el => el=el.object_type_code)
    gdd.objects =  [...gdd.origObjects]
    Object.assign(groupDialogData,gdd)
    groupDialogVisible.value = true
//console.log("groupDialogData",groupDialogData)
    return false
}

const otCodeMap = computed(()=>arrayToMap(st.ot.list,null,"code"))
const nodes = computed(()=>buildNodes())
const filteredNodes = computed(()=> {
    return nodes.value.filter(item=>!hasRemovedParent(item)
        && (showDeletedNode.value?true:!item.hide))
        .sort((a,b)=>a.ordnung-b.ordnung)

})

onMounted(async() => {
    await firstLoad(st)
    dataIsReady.value = true
})


const groupDialogData = reactive({})    //дані, що передаються в діалог
const groupDialogVisible = ref(false)   //показати діалог
const showDeletedNode = ref(false)      //показувати видалені вузли
const activeGroupMenu =  ref([])

//структура дерева
const nodesPlan= [
    {
        type: "root",
        code: "ot_customers",
        icon: rootIcon,
        fixed: true,
        options:[
            { name: "Додати групу закладів", obj: "grp",act:"add"},
            { name: "Додати заклад", obj: "customer",act:"add" },
            { name: "Додати кластер", obj: "cluster",act:"add"},
            { name: "Додати інструменти", obj: "tool",act:"add"},
            { name: "Показати прибрані", obj: "nodes-removed",act:"show"}
        ],
        hideOptions:[
            { name: "Сховати прибрані", obj: "nodes-removed",act:"hide"}
        ]
    },
    {
        type: "grp",
        code: "ot_custBranch",
        icon: "<span style='font-size:20px;margin:0 3px'>🖧</span>",
        label: "Назва групи закладів",
        fixed: true,
        options:[
            { name: "Редагувати групу закладів", obj: "grp",act:"edit"},
            { name: "Видалити групу закладів", obj: "grp",act:"delete" },
            { name: "Додати заклад в групу", obj: "customer",act:"add" },
            { name: "Додати кластер в групу", obj: "cluster",act:"add" },
            { name: "Додати інструменти", obj: "tool",act:"add"}
        ],
        hideOptions:[
            { name: "Повернути групу закладів", obj: "grp",act:"restore"},
            { name: "Видалити групу назавжди", obj: "grp",act:"delete"}
        ]
    },
    {
        type: "customer",
        code: "ot_customer",
        icon: "<span style='font-size:20px;margin:0 3px'>⌂</span>",
        label:"Назва закладу",
        options:[
            { name: "Редагувати заклад", obj: "customer",act:"edit" },
            { name: "Прибрати заклад", obj: "customer",act:"remove" },
            { name: "Додати інструменти", obj: "tool",act:"add"}
        ],

        hideOptions:[
            { name: "Повернути заклад", obj: "customer",act:"restore"},
            { name: "Видалити заклад назавжди", obj: "customer",act:"delete"}
        ]
    },
    {
        type: "cluster",
        code: "ot_cluster",
        icon: "<span style='font-size:25px;margin:0 3px'>⁘</span>",
        label:"Назва корпоративного кластеру",
        options:[
            { name: "Редагувати кластер", obj: "cluster",act:"edit" },
            { name: "Прибрати кластер", obj: "cluster",act:"remove" },
            { name: "Додати інструменти", obj: "tool",act:"add"}
        ],

        hideOptions: [
            { name: "Повернути кластер", obj: "cluster",act:"restore"},
            { name: "Видалити кластер назавжди", obj: "cluster",act:"delete"}
        ]
    },
    {
        type: "tool",
        code: "ot_menu",
        icon: "<span style='font-size:16px;margin:0 3px'>○</span>",
        label:"Інструмент:",
        tag: "Меню",
        ordnung:1,
        fixed: true,
        options:[
            { name: "Прибрати інструмент 'Меню'", obj: "tool",act:"remove"}
        ] ,
        hideOptions:  [
            { name: "Повернути базу меню", obj: "tool",act:"restore"},
            { name: "Видалити базу меню назавжди", obj: "tool",act:"delete"}
        ]
    },

    {
        type: "tool",
        code: "ot_clients",
        icon: "<span style='font-size:16px;margin:0 3px'>○</span>",
        label:"Інструмент:",
        tag: "Клієнти",
        fixed: true,
        ordnung:2,
        options: [{ name: "Прибрати інструмент 'Клієнти'", obj: "tool", act:"remove"}],
        hideOptions: [
            { name: "Повернути базу клієнтів", obj: "tool",act:"restore"},
            { name: "Видалити базу клієнтів назавжди", obj: "tool",act:"delete"}
        ]
    },


    {
        type: "tool",
        code: "ot_orders",
        icon: "<span style='font-size:16px;margin:0 3px'>○</span>",
        label:"Інструмент:",
        tag: "Замовлення",
        fixed: true,
        ordnung:3,
        options:[
            { name: "Прибрати інструмент 'Замовлення'", obj: "tool",act:"remove"}
        ] ,
        hideOptions:  [
            { name: "Повернути перегляд замовлень", obj: "tool",act:"restore"},
            { name: "Видалити перегляд замовлень назавжди", obj: "tool",act:"delete"}
        ]
    },

    {
        type: "tool",
        code: "ot_payments",
        icon: "<span style='font-size:16px;margin:0 3px'>○</span>",
        label:"Інструмент:",
        tag: "Проплати",
        fixed: true,
        ordnung:4,
        options:[
            { name: "Прибрати інструмент 'Проплати'", obj: "tool",act:"remove"}
        ] ,
        hideOptions:  [
            { name: "Повернути перегляд проплат", obj: "tool",act:"restore"},
            { name: "Видалити перегляд проплат назавжди", obj: "tool",act:"delete"}
        ]
    },
        {
        type: "tool",
        code: "ot_reports",
        icon: "<span style='font-size:16px;margin:0 3px'>○</span>",
        label:"Інструмент:",
        tag: "Звіти",
        fixed: true,
        ordnung:4,
        options:[
            { name: "Прибрати інструмент 'Звіти'", obj: "tool",act:"remove"}
        ] ,
        hideOptions:  [
            { name: "Повернути звіти", obj: "tool",act:"restore"},
            { name: "Видалити звіти назавжди", obj: "tool",act:"delete"}
        ]
    }
]

//мапа структури дерева по ключу code
const nodesPlanMap = toMap(nodesPlan,"code") //computed(() => toMap(nodesPlan,"code"))
//масив всіх кодів вузлів з типом "tool"
let objTypeCodes = nodesPlan.filter(n=>n.type=="tool").map(el=>el.code)

//масив всіх об'єктів nodesPlan з типом "tool"
let tools = nodesPlan.filter(n=>n.type=="tool").sort((a,b)=>a.ordnung-b.ordnung)

//масив всіх кодів з типом "tool", які є обов'язковими
let objFixedCodes = nodesPlan.filter(n=>n.type=="tool" && n.fixed).map(el=>el.code)
//id кореневого об'єкту
const rootId = computed(()=> nodes.value.find((item)=>item.object_type_type=="root")?.id)

//мапа вузлів дерева по id
const nodeMap = reactive(new Map())

function buildNodes(){
    const nodesRes = st.otTree.list
    let codes=Array.from(nodesPlanMap.keys())
    let nodeList = fillNewObjectArray(
        nodesRes,
        ['id','name','parent_id','object_type_id','hide','ordnung'],
        ((el,index)=> {
            el.expanded = true
            el.object_type_code = st.ot.idMap.get(el.object_type_id).code
            //el.ordnung = (el.parent_id==1 || el.object_type_code=="ot_custConfig")?1:null
            let nPlan = nodesPlanMap.get(el.object_type_code)
            el.ordnung  = nPlan?.ordnung || null
            el.fixed = nPlan?.fixed || false
            el.sortBucket = nPlan?.type == 'tool' ? 0 : 1
            if (nPlan?.type=='tool') el.name = nPlan.tag
            el.object_type_type = nPlan.type // nodesPlanMap.get(el.object_type_code).type
            el.prefix = nPlan.icon
            el.className= nPlan.type=='tool'?"tool":""
//el.name+=" "+el.id
        }),
        (el=> {
            return codes.includes(st.ot.idMap.get(el.object_type_id).code)
        })
    )
    arrayToMap(nodeList,nodeMap)
    return nodeList
}

function onChangeObjectDailog(event){
}

function getSiblingNodesForSort(parentId, objectTypeCode, excludeId = null) {
    const targetPlan = nodesPlanMap.get(objectTypeCode)
    const targetBucket = targetPlan?.type == 'tool' ? 0 : 1
    return nodes.value.filter(node =>
        (node.parent_id ?? null) === (parentId ?? null) &&
        node.id !== excludeId &&
        !node.hide &&
        (node.sortBucket ?? 0) === targetBucket
    )
}

function getNextOrdnung(parentId, objectTypeCode, excludeId = null) {
    const siblings = getSiblingNodesForSort(parentId, objectTypeCode, excludeId)
    const ordnungen = siblings
        .map(node => node.ordnung)
        .filter(value => Number.isInteger(value))
    if (ordnungen.length === 0) return undefined
    return Math.max(...ordnungen) + 1
}


async function onConfirmGroupDialog(){

    groupDialogVisible.value = false
    let act = groupDialogData.action
    let otCode = groupDialogData.object_type_code
    let otType =  nodesPlanMap.get(otCode).type
//console.log("act::",act)
    let payload = {}
    let responses = []
    const {id, name, parent_id, object_type_id, hide} = groupDialogData
    payload = {id, name, parent_id, object_type_id, hide}

    if (['grp.add'].includes(act)){
        let code = nodesPlan.find(item=>item.type=='grp').code
        payload.object_type_id=otCodeMap.value.get(code).id
        const nextOrdnung = getNextOrdnung(payload.parent_id, code)
        if (nextOrdnung !== undefined) payload.ordnung = nextOrdnung
        delete payload.id
        responses[0] = await onCreateNode(payload)
        if(responses[0]) nodeMap.set(responses[0].id,{
            id:responses[0].id,
            expanded:true,
            fixed:act=='grp.add',
            object_type_code:code,
            sortBucket: nodesPlanMap.get(code)?.type == 'tool' ? 0 : 1,
            ordnung: responses[0].ordnung,
            object_type_type: nodesPlanMap.get(code).type
        })
    }

    else if (["customer.add","cluster.add"].includes(act)){
        let code
        if(act=="customer.add")code = nodesPlan.find(item=>item.type=="customer").code
        else  code = nodesPlan.find(item=>item.type=="cluster").code
        payload.object_type_id=otCodeMap.value.get(code).id
        delete payload.id
        responses[0] = await onCreateNode(payload)
        objFixedCodes.forEach(async c=>{
            payload.object_type_id=otCodeMap.value.get(c).id
            payload.parent_id=responses[0].id
            responses.push(await onCreateNode(payload))
        })

    }
    else if (["grp.edit","cluster.edit","customer.edit"].includes(act)){
        responses[0] = await onUpdateNode(payload.id, payload)
    }
    else if (["grp.remove","cluster.remove","customer.remove"].includes(act)){
        responses[0] = await onRemoveNode(payload.id, payload)
    }
    else if (["grp.restore","cluster.restore","customer.restore"].includes(act)){
        responses[0] = await onRestoreNode(groupDialogData.id)
    }
    else if (["grp.delete","cluster.delete","customer.delete"].includes(act)){
        let childNodes = nodes.value.filter(n => n.parent_id == groupDialogData.id)
        let hasSoftDeleted=childNodes.some(n=>n.hide==true)
        if(childNodes.length>0) {
            let errorText="Можна видалити тільки порожню гілку"
            if(hasSoftDeleted) errorText+=" (гілка містить видалений об'єкт налаштування)."
            ElMessageBox.alert(errorText, {confirmButtonText: 'Гаразд', type: 'error'})
            return false
        }
        return await onDeleteNode(groupDialogData.id)
    }
    else if (act == "tool.add"){

        let diff = groupDialogData.objects.filter(item =>!groupDialogData.origObjects.includes(item))
        if(!diff || diff.length==0) return true
        const missingCodes = diff.filter(code => !otCodeMap.value.get(code))
        if (missingCodes.length) {
            ElMessageBox.alert(`Тип об'єкта ще не зареєстрований у системі: ${missingCodes.join(', ')}. Зверніться до адміністратора.`, {confirmButtonText: 'Гаразд', type: 'error'})
            diff = diff.filter(code => otCodeMap.value.get(code))
            if (!diff.length) return false
        }
        diff.forEach(async code =>{
            let obj = otCodeMap.value.get(code)
            payload.name = nodesPlanMap.get(code).tag
            payload.object_type_id = obj.id
            const nextOrdnung = getNextOrdnung(payload.parent_id, code)
            if (nextOrdnung !== undefined) payload.ordnung = nextOrdnung
            else delete payload.ordnung
            delete payload.id
            let resp = await onCreateNode(payload)
            responses.push(resp)

        })
    }
    else if (act == "tool.remove"){
       responses[0] = await onRemoveNode(groupDialogData.id)
    }
    else if (act == "tool.delete"){
       responses[0] = await onDeleteNode(groupDialogData.id)
    }
    else if (act == "tool.restore"){
        let {branchIsBusy}=checkRestoreObjNode(groupDialogData.id,groupDialogData.parent_id)
        if(branchIsBusy){
            let movedNode = nodeMap.get(groupDialogData.id)
            alertMessage(`Інструмент '${movedNode.name}' вже присутній в цій гілці`)
            return false
        }
        responses[0] = await onRestoreNode(groupDialogData.id)
    }

    else return false
    responses.forEach(resp=>{
        let mapNode=nodeMap.get(resp.id)
        if(!mapNode)return
        let keys=["id","parent_id","name","object_type_id","hide","ordnung","className","object_type_code"]
        keys.forEach(key => {if(key in resp){mapNode[key]=resp[key]}})
    })

}


function checkRestoreObjNode(nodeId, tarBranchId){
    let movedNode = nodeMap.get(nodeId)
    let targetBranch = nodeMap.get(tarBranchId)
    let movePlan = nodesPlanMap.get(movedNode.object_type_code)
    let tarPlan = nodesPlanMap.get(targetBranch.object_type_code)
    let tarBrother = nodes.value.find(br=>{

        return  br.parent_id ==  tarBranchId                               //брат в гілці призначення
                && br.object_type_code == movedNode.object_type_code       //код брату збігається з кодом елемента
                && br.id != nodeId                                         //брат не э елементом
                && br.hide == false                                        //брат не видалений
                //&& movedNode.hide == false                                 //елемент не видалений
    })
    let disabledTarget = tarPlan.type == "tool" || movePlan.type == tarPlan.type
    let branchIsBusy =  !! tarBrother
    return {branchIsBusy,disabledTarget}
}

//функція визначає, чи є el нащадком soft deleted вузла
function hasRemovedParent(current) {
    if(current.id==rootId.value) return false
    while (current) {
        //if(current.hide) return true
        if(current.parent_id === rootId.value) return false
        current = nodeMap.get(current.parent_id)
        if(!current || current.id == current.parent_id) return true
    }
    return true
}

</script>

<style scoped lang="scss">

.sidebar {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-right: 1px solid #ffbf1f;
    flex: 0 0 280px;
    width: 280px;
    min-width: 280px;
    max-width: 280px;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    transition: flex-basis .15s ease, width .15s ease, min-width .15s ease;

    &--collapsed {
        flex: 0 0 40px;
        width: 40px;
        min-width: 40px;
        max-width: 40px;
        padding: 0 4px;
    }
}
.sidebar__toggle {
    flex: 0 0 auto;
    align-self: flex-end;
    margin-top: 10px;
    width: 26px;
    height: 26px;
    border: 1px solid #ffbf1f;
    border-radius: 4px;
    background: #fff;
    color: #b8860b;
    font-size: 14px;
    line-height: 1;
    cursor: pointer;
}
.sidebar--collapsed .sidebar__toggle {
    align-self: center;
    margin-top: 10px;
}
.sidebar__tree {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
}
.sidebar :deep(.left-panel) {
    margin-right: 0 !important;
}
/*
:deep(.object){
    font-weight: bold;
    &>span{
        font-size: 13px;
    }
}
*/
:deep(.el-dialog){
    width: 400px;
    .dialog-field{
        margin-top:20px;
        &>label{
            font-weight: bold;
            font-size: 12px;
            margin-bottom: 15px;
            display: block;
            &>span{
                font-weight: normal;
                margin-left: 10px;
            }
        }
        /*
        .el-checkbox {
            display: inline-block;
            width: fit-content;
            margin-right: 10px;
            margin-top: 5px;
        }*/
    }
}

:deep(.el-checkbox){
    display: block;
}

:deep(.tree-row){
    height: 25px;
    line-height: 25px;
    .tree-title{
        font-size: 12px;
        font-weight: bold;
    }
    &.tool .tree-title{
        font-size: 14px;
        font-weight: normal; 
    }
}

:deep(.el-dropdown){
    z-index: 1;
}
</style>
